<template>
  <v-container grid-list-lg>
    <v-row no-gutters>
      <v-col>
        <Header
          :title="'Objednávka č. '+ $route.params.id"
          :subtitle="'V marketingu platí zásada, že treba prezentovať výhody a nie vlastnosti produktov. Pomôžte zákazníkovi vyriešiť jeho problém, splniť jeho túžbu.'"
        />
      </v-col>
    </v-row>
    <v-row v-if="order != null">
      <v-col>
        <v-card>
          <v-card-title primary-title>Produkt - {{order.orderDetails[0].storageCard.product.name}}</v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Názov</th>
                    <th class="text-center">Rozmery</th>
                    <th class="text-right">Count</th>
                    <th class="text-center">Materiál</th>
                    <th class="text-center">Pradná</th>
                    <th class="text-center">Zadná</th>
                    <th class="text-center">Lavá</th>
                    <th class="text-center">Pravá</th>
                    <th class="text-center">Popis</th>
                    <th class="text-center">Otáčanie</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in order.orderDetails[0].storageCard.product.boards"
                    :key="item.id"
                  >
                    <td class="text-left">{{ item.name }}</td>
                    <td>{{ item.width }} x {{item.height}} mm</td>
                    <td class="text-right">{{ item.quantity }} ks</td>
                    <td>{{ item.decor.name }}</td>
                    <td>{{ item.edgeFrontDecor != null ? item.edgeFrontDecor.name : '-'}}</td>
                    <td>{{ item.edgeBackDecor != null ? item.edgeBackDecor.name : '-'}}</td>
                    <td>{{ item.edgeLeftDecor != null ? item.edgeLeftDecor.name : '-'}}</td>
                    <td>{{ item.edgeRightDecor != null ? item.edgeRightDecor.name : '-'}}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.rotate }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="getOptimization">Výsledky optimalizácie</v-btn>
        <v-row>
          <v-col v-for="item in optimizationResult" :key="item.id" cols="3">
            <v-card flat tile class="d-flex" @click="downloadImage(item.optimizationImage)">
              <v-img max-height="200" aspect-ratio="1" contain :src="toImage(item)" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Order",
  components: {
    Header
  },
  data: () => ({
    order: null,
    optimizationResult: null
  }),

  computed: {},

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.services
        .orderService()
        .getOrder(this.$route.params.id)
        .then(response => {
          this.order = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    getOptimization() {
      let optGuid = this.order.orderDetails[0].storageCard.product
        .optimizationId;
      this.services
        .productService()
        .getProductOptimization(optGuid)
        .then(response => {
          this.optimizationResult = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },
    toImage(data) {
      return `data:image/png;base64,${data.optimizationImage}`;
    },
    downloadImage(data) {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:image/png;base64," + data; //Image Base64 Goes here
      a.download = "Image.png"; //File name Here
      a.click(); //Downloaded file
    }
  }
};
</script>
